import { combineReducers } from 'redux';
import { coreInitiativesLinksAddSyncSlice } from './add';
import { coreInitiativesLinksGetAsyncSlice } from './get';
import { coreInitiativesLinksPostAsyncSlice } from './post';
import { coreInitiativesLinksRemoveSyncSlice } from './remove';
import { coreInitiativesLinksUpdateSyncSlice } from './update';

import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { coreInitiativesLinksByIdReducers, coreInitiativesLinksByIdWatchers } from './_id';

export const coreInitiativesLinksReducers = combineReducers({
	byId: coreInitiativesLinksByIdReducers,
	get: joinCollectionReducers([
		coreInitiativesLinksGetAsyncSlice.asyncReducers,
		coreInitiativesLinksAddSyncSlice.syncReducer,
		coreInitiativesLinksRemoveSyncSlice.syncReducer,
		coreInitiativesLinksUpdateSyncSlice.syncReducer
	], coreInitiativesLinksGetAsyncSlice.asyncState),
	post: coreInitiativesLinksPostAsyncSlice.asyncReducers
});

export const coreInitiativesLinksWatchers = combineAllWatchers([
	coreInitiativesLinksByIdWatchers,
	coreInitiativesLinksGetAsyncSlice.asyncWatchers,
	coreInitiativesLinksPostAsyncSlice.asyncWatchers
]);
